export const profileGeneralForm = {
	fieldContainer: {
		display: 'grid',
		gridTemplateColumns: '1fr 1fr',
		gap: '32px',
		width: '100%',

		'@media (max-width: 900px)': {
			gridTemplateColumns: '1fr',
			gap: '24px',
		},
	},

	column: {
		display: 'flex',
		flexDirection: 'column',
		gap: '16px',
	},

	widgetTitle: {
		fontSize: '18px',
		fontWeight: 600,
		color: 'var(--neutral-900)',
		marginBottom: '8px',
		paddingBottom: '8px',
		borderBottom: '1px solid var(--neutral-100)',
	},

	doubleField: {
		display: 'flex',
		gap: '16px',
		width: '100%',
		'@media (max-width: 639.98px)': {
			flexDirection: 'column',
		},
	},

	doubleFieldWrap: {
		flex: 1,
	},

	widget: {
		padding: '24px',
		border: '1px solid var(--neutral-100)',
		borderRadius: '12px',
		background: 'var(--neutral-50)',
		marginBottom: '24px',
	},
};

// export const profileGeneralForm = {
// 	red: {
// 		color: 'var(--error-500)',
// 		'&:hover': {
// 			color: 'var(--error-400)',
// 		},
// 	},

// 	formTitle: {
// 		marginBottom: '16px',
// 		width: 'calc(50% - 12px)',
// 		'&:npm-child(2n - 1) ': {
// 			marginRight: '24px',
// 		},
// 	},

// 	fieldContainer: {
// 		display: 'flex',
// 		flexWrap: 'wrap',
// 		justifyContent: 'space-between',

// 		'@media (max-width: 639.98px)': {
// 			flexDirection: 'column',
// 			flexWrap: 'nowrap',
// 			width: '100% !important',
// 		},
// 	},

// 	field: {
// 		width: 'calc(50% - 12px)',
// 		marginBottom: '8px',
// 		'&:npm-child(2n - 1) ': {
// 			marginRight: '24px',
// 		},

// 		'@media (max-width: 639.98px)': {
// 			width: '100% !important',
// 			marginRight: '0px !important',
// 		},
// 	},

// 	widget: {
// 		padding: '16px',
// 		border: '1px solid var(--neutral-100)',
// 		borderRadius: '8px',
// 		background: 'var(--neutral-50)',
// 		display: 'flex',
// 		justifyContent: 'space-between',
// 		alignItems: 'center',
// 		marginBottom: '24px',

// 		'@media (max-width: 639.98px)': {
// 			width: '100%',
// 		},
// 	},

// 	widgetTitle: {
// 		fontSize: '16px',
// 		color: 'var(--neutral-900)',
// 	},

// 	doubleField: {
// 		display: 'flex',

// 		'@media (max-width: 639.98px)': {
// 			flexDirection: 'column',
// 			width: '100%',
// 		},
// 	},

// 	doubleFieldWrap: {
// 		marginRight: '16px',

// 		'@media (max-width: 639.98px)': {
// 			marginRight: '0px',
// 			width: '100%',
// 		},
// 	},
// };
